<template>
  <v-app id="inspire">
    <router-view></router-view> 
    <div ref="alertsZone" class="alerts-zone"></div>
  </v-app>
</template>

<script>

import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router'
import store from './stores'

import Alert from './components/Alert'


/* ROMOVE FROM HERE */
import moment from 'moment'

Vue.filter('formatDate', function(value) {  
  if (value) {
    return moment(String(value)).format('DD/MM/YY HH:mm:ss');
  }
})

/* /ROMOVE FROM HERE */

// Axios
Vue.use(VueAxios, axios)

export default {
  name: 'App',
  router,
  store,
  props: {
    source: String,
  },
  components:{
    'Alert' : Alert
  },
  methods:{
    createAlert( params ) {
      var ComponentClass = Vue.extend(Alert)
      var instance = new ComponentClass({
          propsData: { 
              type: (params && params.type)?params.type:'success',
              content: (params && params.content)?params.content:''
          }
      })

      instance.$mount()
      this.$refs.alertsZone.appendChild(instance.$el)
    },
    destroyAlerts(){
      //TODO
    }
  },
  computed:{
    notifications (){
      this.$store.getters.getNotifications;
    }
  },
  created () {
    window.console.log("app created")
    this.$vuetify.theme.dark = true
    // Attach event
    this.$root.$on('createAlert',this.createAlert);
  },
  beforeDestroy() {
    this.$root.$off('createAlert',this.createAlert);
  }
};
</script>

<style scoped>
  a {  
    text-decoration: none;
  }
  .alerts-zone{
    opacity: .9;
    position: fixed;
    /*width: 100%;*/
    box-sizing: border-box;
    bottom: 0px;
    z-index: 99;
    padding: 10px;
    right: 0;
  }
</style>
